export const linearProgress = {
    bandWidth: 30,
    progress: {
        style: {
            fillOpacity: 1
        }
    },
    track: {
        style: {
            fill: "#E7EBED",
            fillOpacity: 1
        }
    }
};
//# sourceMappingURL=linear-progress.js.map
